import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { relevantStatusForYoy } from '../../../../constants/assessmentStatus';

const scoreWrapperStyle = css({
  textAlign: 'center',
});

const negativeYoyChangeStyle = css({
  color: 'red',
});
const positiveYoyChangeStyle = css({
  color: 'green',
});
const neutralYoyChangeStyle = css({
  color: 'black',
});

const getScoreCellStyle = (yoyChange) => {
  if (yoyChange > 0) {
    return positiveYoyChangeStyle;
  }

  if (yoyChange < 0) {
    return negativeYoyChangeStyle;
  }

  return neutralYoyChangeStyle;
};

const ScoreCell = ({ cell: { value }, row }) => {
  const yoyChange =
    row.original.lastYearScore !== null &&
    row.original.lastYearScore !== undefined
      ? value - row.original.lastYearScore
      : undefined;

  return (
    <div css={scoreWrapperStyle}>
      {value && <span>{`${value}%`}</span>}
      {yoyChange !== undefined && relevantStatusForYoy(row.original.status) && (
        <span css={getScoreCellStyle(yoyChange)}>{` (${
          yoyChange > 0 ? '+' : ''
        }${yoyChange}%)`}</span>
      )}
    </div>
  );
};

ScoreCell.propTypes = {
  cell: PropTypes.shape({
    value: PropTypes.number,
  }).isRequired,
  row: PropTypes.shape({
    original: PropTypes.shape({
      lastYearScore: PropTypes.number,
      status: PropTypes.string,
    }),
  }).isRequired,
};

export { ScoreCell };
